import React, { useEffect, useState } from 'react'
import NotFoundPage from '../NotFoundPage'
import { decodeToken } from "react-jwt";
import AdminNav from '../AdminNav';
import axios from "axios";
import "./Insight.css";

function Insight() {
    const { REACT_APP_API_URL } = process.env;

    const token = localStorage.getItem("access_token");
    const decodedToken = decodeToken(token);
    const [salesAmount, setSalesAmount] = useState(0);
    const [name, setName] = useState("fiddle");
    const [monthSale, setMonthSale] = useState(0);
    const [everTotal, setEverTotal] = useState(0);
    const [allPurchases, setAllPurchases] = useState([]);
    const formatter = new Intl.DateTimeFormat('en-us', { month: 'long' });
    const date = new Date();
    const month = formatter.format(date);
    const getSalesToday = async () => {
        try {
            const result = await axios.post(
                `${REACT_APP_API_URL}/get-sales-amount/`,
                {
                    //body
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer " + token
                    }
                }
            );
            setSalesAmount(result.data[0].total);
        } catch (error) { }
    }

    const getTopCustommer = async () => {
        try {
            const result = await axios.post(
                `${REACT_APP_API_URL}/get-top-customer/`,
                {
                    //body
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer " + token
                    }
                }
            );
            setName(result.data[0]);
        } catch (error) { }
    }


    const getEverTotal = async () => {
        try {
            const result = await axios.post(
                `${REACT_APP_API_URL}/get-total-sales-amount/`,
                {
                    //body
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer " + token
                    }
                }
            );
            setEverTotal(result.data[0]);
        } catch (error) { }
    }


    const getAllPurchases = async () => {
        try {
            const result = await axios.post(
                `${REACT_APP_API_URL}/get-all-purchases/`,
                {
                    //body
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer " + token
                    }
                }
            );
            setAllPurchases(result.data);
        } catch (error) { }
    }

    const getMonthlyTotal = async () => {
        try {
            const result = await axios.post(
                `${REACT_APP_API_URL}/get-month-sales/`,
                {
                    //body
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer " + token
                    }
                }
            );
            setMonthSale(result.data[0]);
        } catch (error) { }
    }

    useEffect(() => {
        getSalesToday();
        getTopCustommer();
        getMonthlyTotal();
        getEverTotal();
        getAllPurchases();
    })

    if (decodedToken?.role === 1) {
        return (
            <div className="container product-section">
                <div className="shop-section">
                    <AdminNav />
                    <div className="card-container">
                        <div className="username-section card" style={{ textAlign: 'center' }}>
                            <h4>Sales today</h4>
                            <br></br>
                            <h2 style={{ fontSize: '24px', textShadow: '0px 0px 10px gold' }}>${salesAmount ? salesAmount : 0}</h2>
                        </div>
                        <div className="username-section card" style={{ textAlign: 'center' }}>
                            <h4>Top custommer</h4>
                            <br></br>
                            <h2 style={{ fontSize: '24px', textShadow: '0px 0px 10px gold' }}>{name.username}</h2> <br></br><span style={{ textShadow: '0px 0px 10px green', color: 'green', fontSize: '18px' }}>${name.total}</span>
                        </div>
                        <div className="username-section card" style={{ textAlign: 'center' }}>
                            <h4>Total sales <span style={{ color: 'red', textShadow: '0px 0px 10px red' }}>{month}</span></h4>
                            <br></br><br></br><span style={{ textShadow: '0px 0px 10px green', color: 'green', fontSize: '32px', fontWeight: 'bold' }}>${monthSale.total}</span>
                        </div>
                        <div className="username-section card" style={{ textAlign: 'center' }}>
                            <h4>Total sales</h4>
                            <br></br><br></br><span style={{ textShadow: '0px 0px 10px green', color: 'green', fontSize: '32px', fontWeight: 'bold' }}>${everTotal.total}</span>
                        </div>
                    </div>
                    <table style={{ marginTop: '50px' }}>
                        <tr><td>Username</td> <td>Item name</td> <td>Quantity</td> <td>Redeemed</td> <td>Redeemed at</td> <td>Buy date</td></tr>
                        {allPurchases.map(purchase => {
                            return (<tr><td>{purchase.username}</td><td>{purchase.item_name}</td><td>{purchase.quantity}</td><td> {purchase.redeemed === 1 ? "yes" : "no"}</td><td>{purchase.redeemed_at}</td><td>{purchase.buy_date}</td></tr>)
                        })}
                    </table>

                </div>
            </div >
        )
    } else {
        return (<NotFoundPage />)
    }
}

export default Insight